import React from 'react';
import { SquareRemoveButton } from '../../../../../../components/Button';

interface IProps {
  onClick: () => void;
}

const RemoveVariantAction = ({ onClick }: IProps) => {
  return <SquareRemoveButton onClick={onClick} content={'Remove Variant'} />;
};

export default RemoveVariantAction;
